{
  "bulkApplyConfirm": {
    "buttons": {
      "applying": "En cours...",
      "cancel": "Annuler",
      "confirm": "Confirmer"
    },
    "helperText": "Texte d'aide",
    "loading": "Chargement",
    "message": "Appliquer en lot",
    "summary": {
      "alreadyMapped": "Déjà associé",
      "newMappings": "Nouv. corresp.",
      "totalRows": "Lignes au total"
    },
    "title": "Appliquer en lot"
  },
  "flightBridgeStatus": {
    "pendingTenants": {
      "allMatched": "Tous trouvés",
      "buttons": {
        "refresh": "Actualiser",
        "removeAndRetry": "Supprimer et réessayer"
      },
      "columns": {
        "aircraftType": "Type d'aéronef",
        "created": "Créé",
        "fbo": "Fbo",
        "operator": "Opérateur",
        "source": "Source",
        "tailNumber": "Immatriculation"
      },
      "description": "Description",
      "dialog": {
        "autoRetry": {
          "description": "Description",
          "title": "Réessai auto"
        },
        "buttons": {
          "cancel": "Annuler",
          "removeAndRetry": "Supprimer et réessayer",
          "removing": "Suppression"
        },
        "message": "Dialogue",
        "reQuarantine": "Requarantaine",
        "title": "Fenêtre"
      },
      "errors": {
        "resolveFailed": "Erreur : Échec de la résolution"
      },
      "noPendingTenants": "Aucun locataire en attente",
      "pendingCount": "Nombre en attente",
      "selectedCount": "Sélection",
      "title": "Locataires en attente",
      "unknownFBO": "FBO inconnu",
      "unknownOperator": "Opérateur inconnu",
      "unknownType": "Type inconnu"
    }
  },
  "obstacleEdit": {
    "buttons": {
      "cancel": "Annuler",
      "create": "Créer",
      "save": "Enregistrer"
    },
    "errors": {
      "fileSizeLimit": "Erreur : Taille limite du fichier",
      "fileTypeInvalid": "Erreur : type de fichier non valide"
    },
    "helperText": {
      "keepCurrent": "Rester à jour"
    },
    "image": {
      "changeButton": "Modifier le bouton",
      "preview": "Aperçu",
      "selected": "Sélectionné",
      "uploadButton": "Bouton d'envoi"
    },
    "labels": {
      "height": "Hauteur",
      "length": "Longueur",
      "name": "Nom",
      "obstacleImage": "Image de l'obstacle",
      "width": "Largeur"
    },
    "placeholders": {
      "height": {
        "create": "Créer",
        "edit": "Édit."
      },
      "length": {
        "create": "Créer",
        "edit": "Modif."
      },
      "name": {
        "create": "Créer"
      },
      "width": {
        "create": "Créer",
        "edit": "Modif."
      }
    },
    "title": {
      "create": "Créer",
      "edit": "Édit."
    }
  },
  "towingEquipmentEdit": {
    "buttons": {
      "cancel": "Annuler",
      "create": "Créer",
      "save": "Enregistrer"
    },
    "helperText": {
      "keepCurrent": "Rester à jour",
      "noFootprint": "Aucun gabarit"
    },
    "labels": {
      "height": "Hauteur",
      "length": "Longueur",
      "name": "Nom",
      "noFootprint": "Aucun gabarit",
      "towBar": "Barre rem.",
      "width": "Largeur"
    },
    "placeholders": {
      "height": {
        "create": "Créer",
        "edit": "Modif."
      },
      "length": {
        "create": "Créer",
        "edit": "Édit."
      },
      "name": {
        "create": "Créer"
      },
      "towBar": {
        "create": "Créer",
        "edit": "Édit."
      },
      "width": {
        "create": "Créer",
        "edit": "Édit."
      }
    },
    "title": {
      "create": "Créer",
      "edit": "Édit."
    }
  }
}
